import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GridOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"grid_off"}/>
}
